import { render, staticRenderFns } from "./RomList.vue?vue&type=template&id=e624533a&scoped=true&"
import script from "./RomList.vue?vue&type=script&lang=js&"
export * from "./RomList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e624533a",
  null
  
)

export default component.exports